module.exports = __webpack_public_path__ + "static/media/21-12.56a19cd7.mp3";